import { CardHeader, Skeleton } from '@mui/material';

const NotificationSkeleton = () => {
  return (
    <CardHeader
      avatar={<Skeleton variant="circular" width={48} height={48} />}
      title={
        <Skeleton
          variant="rectangular"
          height={20}
          width="100%"
          style={{ marginBottom: 6 }}
        />
      }
      subheader={<Skeleton variant="rectangular" height={16} width="100%" />}
      sx={{
        width: '100%',
        padding: '16px 12px 16px 16px',
        boxSizing: 'border-box',
        '.MuiCardHeader-avatar': {
          marginRight: '8px',
        },
      }}
    ></CardHeader>
  );
};

export default NotificationSkeleton;
